import {useMemo} from 'react';
import type {Schema} from 'schemaDefinition/types';
import type {ThesaurusId} from 'services/thesaurus/types';
import {getSchemaListThesaurusIds} from 'schemaDefinition/functions';

export const useSchemaListThesaurusIds = (schemas: Schema[]): ThesaurusId[] => {
  return useMemo(() => getSchemaListThesaurusIds(schemas), [schemas]);
};
